<template>
  <div class="table-pagination" style="height: 100%">
    <el-table
      :data="tableDataByPage"
      :height="tableHeight"
      :style="{ backgroundColor: 'transparent', color: tableFontColor }"
      class="detail-table"
      resizable
      :highlight-current-row="false"
      :header-row-style="getHearRowStyle"
      :header-cell-style="getHearRowStyle"
      :row-class-name="getRowClassName"
      size="medium"
    >
      <el-table-column label="标题" :show-overflow-tooltip="true" align="center">
        <template slot="header">
          <CustomHeader
            :title="'主题'"
            :search="true"
            :filter-data="requirement"
            @handleTitleSearch="handleTitleSearch"
          ></CustomHeader>
        </template>
        <template slot-scope="scope">
          <a
            class="title"
            :class="{ 'enable-click': scope.row.link }"
            :href="scope.row.link"
            target="_blank"
          >
            <span>{{ scope.row.title }}</span>
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="processedCategory" :show-overflow-tooltip="true" align="center">
        <template slot="header">
          <div class="table-header-colum">
            <CustomHeader
              :title="'类别'"
              :type-selector="true"
              :type-list="typeList"
              @handleTypeSelect="handleTypeSelect"
            ></CustomHeader>
            <SortTool :sort-key="'processedCategory'" @handleSort="handleSort"></SortTool>
          </div>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" align="center">
        <template slot="header">
          <div class="table-header-colum">
            <CustomHeader
              :title="'日期'"
              :filter-data="requirement"
              :date-selector="true"
              @handleDateSearch="handleDateSearch"
            ></CustomHeader>
            <SortTool :sort-key="'datetime'" @handleSort="handleSort"></SortTool>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.datetime.split(" ")[0] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="this.isShowRegion"
        :show-overflow-tooltip="true"
        prop="region"
        label="地区"
        align="center"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      small
      hide-on-single-page
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="processedTableData.length"
    >
    </el-pagination>
  </div>
</template>

<script>
import CONSTANCE from "@/static/js/constance"
import CustomHeader from "../../Tables/CustomHeader"
import SortTool from "../SortTool"
export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    isShowRegion: {
      type: Boolean,
      default: false,
    },
    typeList: {
      type: Array,
      default: () => [],
    },
    // checkedTypeList: {
    //   type: Array,
    //   default: () => [],
    // }
  },
  components: {
    CustomHeader,
    SortTool,
  },
  data() {
    return {
      tableFontColor: CONSTANCE.GRAPH_FONT_COLOR,
      currentPage: 1,
      pageSize: 20,
      processedTableData: [],
      tableDataTemplate: null,
      // typeList: null,
      requirement: {
        title: "",
        types: null,
        date: "",
      },
    }
  },
  computed: {
    tableDataByPage: function () {
      return this.processedTableData.length > 0
        ? this.processedTableData.slice(
            (this.currentPage - 1) * this.pageSize,
            this.currentPage * this.pageSize
          )
        : []
    },
    isShowPagination: function () {
      return this.tableData.length > this.pageSize
    },
    tableHeight: function () {
      return this.isShowPagination ? "90%" : "100%"
    },
  },
  watch: {
    tableData: {
      handler(newData) {
        this.initTypes(newData)
        //根据条件显示内容
        this.handleChange()
        // this.initTypes()
        // this.processedTableData = newData
      },
      deep: true,
    },
  },
  mounted() {
    this.initTypes(this.tableData)
    // this.initTypes()
  },
  methods: {
    // initTypes() {
    initTypes(tableData) {
      // if (this.tableData.length > 0 && this.tableData[0].processedCategory) return
      // const typeSet = new Set()
      this.processedTableData = tableData.filter((data) => {
        const categorySubCode = data.category.split("-")
        categorySubCode.length > 1
          ? (data.processedCategory = categorySubCode[1])
          : (data.processedCategory = categorySubCode[0])
        // if (!categoryCode) return false
        //若没有二级类型则默认给其他
        // if (!category) data.processedCategory = "其他"
        // else {
        //取消前缀
        // if (!categorySubCode) data.processedCategory = data.category
        // else data.processedCategory = data.category.split("-")[1]
        // typeSet.add(category)
        return true
        // }
      })
      // typeSet.add("其他")
      // this.typeList = Array.from(typeSet)
      this.requirement.types = this.typeList
    },
    getHearRowStyle() {
      return "background-color: transparent;color: #3FF3F1 !important"
    },
    getRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "table-even-row"
      } else return "table-odd-row"
    },
    handleSizeChange(size) {
      this.pageSize = size
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
    },
    handleTitleSearch(value) {
      this.requirement.title = value
      this.handleChange()
      // this.processedTableData = this.tableData.filter((row) => row.title.indexOf(value) > -1)
    },
    handleDateSearch(date) {
      // handleDateSearch(dataRangeArr) {
      // const floor = dataRangeArr[0]
      // const cell = dataRangeArr[1]
      // this.processedTableData = this.tableData.filter((row) => {
      //   const date = row.datetime.split(" ")[0]
      //   return date >= floor && date <= cell
      // })
      this.requirement.date = date
      this.handleChange()
      // this.processedTableData = this.tableData.filter((row) => {
      //   if (row.datetime.indexOf(date) > -1) return row
      // })
    },
    handleTypeSelect(selectedTypeList) {
      this.requirement.types = selectedTypeList
      this.handleChange()
      // this.processedTableData = this.tableData.filter((row) => {
      //   if (selectedTypeList.indexOf(row.processedCategory) > -1) return row
      // })
      // this.currentPage = 1
    },
    handleChange() {
      this.processedTableData = this.tableData.filter((row) => {
        if (this.requirement.title.length > 0 && row.title.indexOf(this.requirement.title) === -1)
          return false
        else if (
          this.requirement.types.length === 0 ||
          (this.requirement.types.length > 0 &&
            this.requirement.types.indexOf(row.processedCategory) === -1)
        )
          return false
        else if (
          this.requirement.date.length > 0 &&
          row.datetime.indexOf(this.requirement.date) === -1
        )
          return false
        else return true
      })
      this.currentPage = 1
    },

    //根据传入参数处理排序，1为升序, -1为降序
    handleSort(data) {
      const { key, flag } = data
      if (flag === 0) {
        this.initTypes(this.tableData)
        // this.processedTableData = this.tableData.filter((data) => {
        //   const categorySubCode = data.categoryCode.split(".")[1]
        //   // if (!categoryCode) return false
        //   //若没有二级类型则默认给其他
        //   // if (!category) data.processedCategory = "其他"
        //   // else {
        //   //取消前缀
        //   if (!categorySubCode) data.processedCategory = data.category
        //   else data.processedCategory = data.category.split("-")[1]
        //   // typeSet.add(category)
        //   return true
        //   // }
        // })
        return
      }
      this.processedTableData = this.processedTableData.sort((a, b) => {
        if (a[key] > b[key]) return flag
        else return -1 * flag
      })
    },
  },
}
</script>

<style lang="scss">
$fontColor: #eee;
.table-header-colum {
  display: flex;
  justify-content: center;
}
.table-pagination {
  height: 100%;
  overflow: hidden;
  .el-pagination {
    text-align: center;
    button {
      background-color: transparent;
      color: $fontColor;
    }
    button:disabled {
      color: #c0c4cc;
    }
    .el-pager,
    .el-pager li {
      background-color: transparent;
      color: rgb(185, 179, 179);
    }
    .el-pager .active {
      background-color: rgba($color: #fff, $alpha: 0.3);
      // color: #3951b3;
      color: $fontColor;
    }
    .el-pagination__total {
      color: rgb(185, 179, 179);
    }
    .el-pagination__jump {
      color: rgb(185, 179, 179);
      .el-pagination__editor.el-input .el-input__inner {
        height: 1.5em;
        background-color: transparent;
        color: $fontColor;
      }
    }
  }
  .detail-table {
    user-select: none;
    .title {
      color: $fontColor;
      text-decoration: none;
      pointer-events: none;
    }
    //设置table每行的高度
    .cell {
      height: 2.5vh;
      line-height: 2.5vh;
    }
    .enable-click {
      cursor: pointer;
      text-decoration: underline;
      pointer-events: auto;
    }
    .el-table__empty-text {
      color: $fontColor;
    }
    .el-table__row {
      &.table-even-row {
        // background-color: #fff;
        background-image: linear-gradient(to bottom, #011435, #1a6547);
      }
      &.table-odd-row {
        background-image: linear-gradient(to bottom, #011435, #2e5076);
      }
      & td:first-child {
        border-radius: 5px 0 0 5px;
      }
      & td:last-child {
        border-radius: 0 5px 5px 0;
      }
    }
    tbody tr:hover > td {
      background-color: rgba($color: #fff, $alpha: 0.1) !important;
    }
    .el-table__body tr.current-row > td {
      background-color: transparent !important;
    }
    &::before {
      height: 0;
    }
    .el-table__row > td {
      /* 去除表格线 */
      border: none;
      // border-bottom: 2px solid rgba($color: #fff, $alpha: 0.2);
    }
    .el-table__header-wrapper {
      //标题条字体大小
      font-size: 14px;
      .el-table__header {
        border-collapse: separate;
        border-spacing: 0;
        //设置table行高
        & tr,
        & td {
          padding: 0;
          height: 20px;
        }
      }
      table th.el-table__cell.is-leaf {
        border-bottom: none;
        padding: 0;
      }
    }

    .el-table__body-wrapper {
      //内容条字体大小
      font-size: 12px;
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #293e79;
        border-radius: 3px;
      }
      &::-webkit-scrollbar-track {
        background-color: #0f1d44;
        border-radius: 3px;
      }

      .el-table__body {
        border-collapse: separate;
        border-spacing: 0 0.5vh;
        //设置table行高

        & tr,
        & td {
          padding: 0;
          height: 2%;
        }
      }
    }

    .el-table__cell.gutter {
      // background-color: transparent;
      // border-bottom: 1px solid #fff;
      display: none !important;
    }

    .el-table__body {
      width: 100% !important;
    }
  }
}
</style>
